import React from 'react';
import { Flex } from '@finect/tabular-core/Flex';
import { Button } from '@finect/tabular-core/Button';
import { TextButton } from '@finect/tabular-core/TextButton';
import { ArrowRight } from '@finect/tabular-icons/arrowRight';
import { Spinner } from '../../../Spinner';
import { Inner } from './partials';
export var PillFooter = function PillFooter(_ref) {
  var pillProps = _ref.pillProps;
  var _pillProps$pillState = pillProps.pillState,
    isLoading = _pillProps$pillState.isLoading,
    hasPrevStep = _pillProps$pillState.hasPrevStep,
    hasNextStep = _pillProps$pillState.hasNextStep,
    currentField = _pillProps$pillState.currentField;
  var unlocked = currentField.unlocked;
  var handleMainAction = function handleMainAction() {
    pillProps.actions.onNextStep();
  };
  var handlePrevStep = function handlePrevStep() {
    pillProps.actions.onPrevStep();
  };
  var actionText = hasNextStep ? 'Siguiente' : 'Finalizar';
  return React.createElement(Inner, null, React.createElement(Flex, {
    align: "center"
  }, isLoading ? React.createElement(Spinner, null) : null), React.createElement("div", null, hasPrevStep ? React.createElement(TextButton, {
    terciary: true,
    onClick: handlePrevStep
  }, 'Atrás') : null, React.createElement(Button, {
    primary: true,
    width: "auto",
    variant: "medium",
    onClick: handleMainAction,
    disabled: !unlocked || isLoading,
    withRightAnimatedIcon: true
  }, React.createElement("span", null, actionText), React.createElement(ArrowRight, null))));
};